import {registerTileSchema} from '#core/application/schema-registry.js';

import PARTICIPANTS from './participants.palette-schema.yaml';

registerTileSchema(PARTICIPANTS);

export function generateParticipants(TILE) {
    const {FONT} = TILE;

    const PARTICIPANTS_TEXT = {
        fontSize: FONT.SIZE_MEDIUM,
        fontWeight: FONT.WEIGHT_BOLD,
        textAlign: 'left',
    };

    return {
        container: {
            style: {
                justifyContent: 'center',
                maxWidth: '100%',
            },
        },
        text: {
            style: {
                ...PARTICIPANTS_TEXT,
                ...TILE.PARTICIPANTS_TEXT,
            },
        },
        startingPitcherName: {
            style: {
                fontSize: FONT.SIZE_XSMALL,
                ...TILE.PITCHER_TEXT,
            },
        },
        outrightText: {
            style: {
                ...PARTICIPANTS_TEXT,
                ...TILE.PARTICIPANTS_OUTER_TEXT,
            },
        },
        separatorText: {
            style: {
                fontSize: FONT.SIZE_XSMALL,
                color: TILE.PARTICIPANTS_SEPARATOR_COLOR,
            },
        },
    };
}
